import { FC } from 'react'
import { useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { MainLayout } from 'views/layouts'
import {
  Card,
  ModulesContainer,
  CardDescriptionSection
}
  from './styled'
import TitleDiv from 'views/components/UI/TitleDiv'
import { useNotification } from 'lib/context/notification.context'
import { superAdminRoutes } from 'router/routes'

const QUESTIONNAIRE_ADMIN_ROLES = new Set([
  'special_admin',
  'super_admin',
  'platform_admin',
  'super_platform_admin',
])

const Home: FC = () => {
  const navigate = useNavigate()
  const { getWarning } = useNotification()
  const role = useSelector((state: any) => state.auth.role)
  const canManageQuestionnaires = QUESTIONNAIRE_ADMIN_ROLES.has(role)

  const handleQuestionnaireClick = () => {
    if (!canManageQuestionnaires) {
      getWarning('Comunícate con el administrador para habilitar esta función.')
      return
    }

    navigate(superAdminRoutes.Cuestionario)
  }

  return (
    <MainLayout>
      <TitleDiv>
        <h2 style={{ fontSize: 32 }}>Configuración módulo Betesa</h2>
      </TitleDiv>
      <ModulesContainer>
        <Card onClick={handleQuestionnaireClick} style={{ cursor: 'pointer' }}>
          <CardDescriptionSection>
            <span style={{ fontWeight: 'bold', color: '#1F2124', fontSize: 20 }}>Cuestionarios</span>
          </CardDescriptionSection>
        </Card>
        <Link to="/modules/talents/actions" style={{ textDecoration: 'none' }}>
          <Card >
            <CardDescriptionSection>
              <span style={{ fontWeight: 'bold', color: '#1F2124', fontSize: 20 }}>Acciones de desarrollo</span>

            </CardDescriptionSection>
          </Card>
        </Link>
        <Link to="/modules/talents/texts" style={{ textDecoration: 'none' }}>
          <Card >
            <CardDescriptionSection>
              <span style={{ fontWeight: 'bold', color: '#1F2124', fontSize: 20 }}>Textos</span>

            </CardDescriptionSection>
          </Card>
        </Link>
      </ModulesContainer>
    </MainLayout>
  )
}
export default Home
